<template>
  <div>
    <div class="bg-white rounded-lg shadow-card mx-auto mb-6">
      <header class="flex flex-col md:flex-row justify-between px-6 py-4">
        <h2 class="font-semibold text-2xl lg:text-2xl py-2">
          Your Event Planner Companies
        </h2>
        <a
          @click="
            $router.push({
              name: 'event-planner.signup',
              params: { uuid: 'new' }
            })
          "
          class="btn btn-secondary font-semibold rounded-lg px-4"
          >Add new company</a
        >
      </header>
      <div>
        <table class="table-fixed text-left w-full text-sm">
          <thead class="hidden md:table-header-group">
            <tr class="border-t border-b border-light-gray px-6 py-4">
              <th class="px-6 py-3">
                <span class="text-dark-gray font-normal">Company Name</span>
              </th>
              <th class="px-6 py-3">
                <span class="text-dark-gray font-normal">Address</span>
              </th>
              <th class="px-6 py-3">
                <span class="text-dark-gray font-normal">City</span>
              </th>
              <th class="px-6 py-3">
                <span class="text-dark-gray font-normal">State</span>
              </th>
              <th class="px-6 py-3">
                <span class="text-dark-gray font-normal">Zip</span>
              </th>
              <th class="px-6 py-3">
                <span class="text-dark-gray font-normal">Status</span>
              </th>
              <th class="px-6 py-3 w-3/12 lg:w-2/12">
                <span class="text-dark-gray font-normal">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody v-if="companies && companies.length > 0">
            <tr
              v-for="(company, index) in companies"
              :key="index"
              class="border-t border-light-gray"
            >
              <td class="block md:table-cell px-6 py-4 md:py-5">
                <div class="md:hidden text-dark-gray mb-2">
                  COMPANY NAME
                </div>
                <div>{{ company.name }}</div>
              </td>
              <td class="block md:table-cell px-6 py-4 md:py-5">
                <div class="md:hidden text-dark-gray mb-2">
                  ADDRESS
                </div>
                <div>{{ company.address }}</div>
              </td>
              <td class="block md:table-cell px-6 py-4 md:py-5">
                <div class="md:hidden text-dark-gray mb-2">
                  CITY
                </div>
                <div>{{ company.city }}</div>
              </td>
              <td class="block md:table-cell px-6 py-4 md:py-5">
                <div class="md:hidden text-dark-gray mb-2">
                  STATE
                </div>
                <div>{{ company.state }}</div>
              </td>
              <td class="block md:table-cell px-6 py-4 md:py-5">
                <div class="md:hidden text-dark-gray mb-2">
                  ZIP
                </div>
                <div>{{ company.zip }}</div>
              </td>
              <td class="block md:table-cell px-6 py-4 md:py-5">
                <div class="md:hidden text-dark-gray mb-2">
                  STATUS
                </div>
                <div>{{ company.status }}</div>
              </td>
              <td class="block md:table-cell px-6 py-4 md:py-5">
                <div class="md:hidden text-dark-gray mb-2">
                  ACTIONS
                </div>
                <div class="flex xs:flex">
                  <router-link
                    class="btn btn-secondary font-semibold rounded-lg px-4 mr-1 w-full xs:w-auto text-center"
                    :to="{
                      name: 'event-planner.dashboard',
                      params: { uuid: company.uuid }
                    }"
                  >
                    <span>View</span>
                  </router-link>
                  <router-link
                    class="btn btn-secondary font-semibold rounded-lg px-4 w-full x:w-auto text-center"
                    :to="{
                      name: 'event-planner.signup',
                      params: { uuid: company.uuid }
                    }"
                  >
                    <span>Edit</span>
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr class="border-t border-light-gray">
              <td colspan="7" class="px-6 py-4">
                <div class="text-center text-white opacity-30 p-4 bg-green-500">
                  You do not have any companies.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["companies"]
};
</script>

<style></style>
